import { VehicleSelectionMethod } from '../enums';
export class VehicleInfoGlobalState {
    constructor() {
        this.domain = {
            vehicleInfo: new VehicleInfoState()
        };
    }
}
export class VehicleInfoState {
    constructor() {
        this.hasVehicleResolved = false;
        this.vehicleInfoData = new VehicleInfoData();
        this.selectedInfoEntries = new Map();
    }
}
/**
 * Represents the raw data retrieved from the vehicle selection api.
 */
export class VehicleInfoData {
    constructor() {
        this.Vin = '';
        this.Vid = 0;
        this.Labels = new VehicleSelectionLabels();
        this.Types = [];
        this.Years = [];
        this.Makes = [];
        this.Models = [];
        this.SubModels = [];
        this.BodyStyles = [];
        this.Engines = [];
        this.Transmissions = [];
        this.DriveTrains = [];
        this.FuelType = [];
        this.VehicleSelectionMethod = VehicleSelectionMethod.VinDecode;
    }
}
export class VehicleSelectionLabels {
}
/**
 * An entry in a collection of entries that describes a possible selection for decoding vehicles.
 */
export class VehicleInfoEntry {
}
//# sourceMappingURL=VehicleInfoGlobalState.js.map